// GENERATED FILE:
const locale =  {
  "en": {
    "CONTROL_FOREVER": "forever",
    "CONTROL_REPEAT": "repeat %1",
    "CONTROL_IF": "if %1 then",
    "CONTROL_ELSE": "else",
    "CONTROL_STOP": "stop",
    "CONTROL_STOP_ALL": "all",
    "CONTROL_STOP_THIS": "this script",
    "CONTROL_STOP_OTHER": "other scripts in sprite",
    "CONTROL_WAIT": "wait %1 seconds",
    "CONTROL_WAITUNTIL": "wait until %1",
    "CONTROL_REPEATUNTIL": "repeat until %1",
    "CONTROL_WHILE": "while %1",
    "CONTROL_FOREACH": "for each %1 in %2",
    "CONTROL_STARTASCLONE": "when I start as a clone",
    "CONTROL_CREATECLONEOF": "create clone of %1",
    "CONTROL_CREATECLONEOF_MYSELF": "myself",
    "CONTROL_DELETETHISCLONE": "delete this clone",
    "CONTROL_COUNTER": "counter",
    "CONTROL_INCRCOUNTER": "increment counter",
    "CONTROL_CLEARCOUNTER": "clear counter",
    "CONTROL_ALLATONCE": "all at once",
    "DATA_SETVARIABLETO": "set %1 to %2",
    "DATA_CHANGEVARIABLEBY": "change %1 by %2",
    "DATA_SHOWVARIABLE": "show variable %1",
    "DATA_HIDEVARIABLE": "hide variable %1",
    "DATA_ADDTOLIST": "add %1 to %2",
    "DATA_DELETEOFLIST": "delete %1 of %2",
    "DATA_DELETEALLOFLIST": "delete all of %1",
    "DATA_INSERTATLIST": "insert %1 at %2 of %3",
    "DATA_REPLACEITEMOFLIST": "replace item %1 of %2 with %3",
    "DATA_ITEMOFLIST": "item %1 of %2",
    "DATA_ITEMNUMOFLIST": "item # of %1 in %2",
    "DATA_LENGTHOFLIST": "length of %1",
    "DATA_LISTCONTAINSITEM": "%1 contains %2?",
    "DATA_SHOWLIST": "show list %1",
    "DATA_HIDELIST": "hide list %1",
    "DATA_INDEX_ALL": "all",
    "DATA_INDEX_LAST": "last",
    "DATA_INDEX_RANDOM": "random",
    "EVENT_WHENFLAGCLICKED": "when %1 clicked",
    "EVENT_WHENTHISSPRITECLICKED": "when this sprite clicked",
    "EVENT_WHENSTAGECLICKED": "when stage clicked",
    "EVENT_WHENTOUCHINGOBJECT": "when this sprite touches %1",
    "EVENT_WHENBROADCASTRECEIVED": "when I receive %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "when backdrop switches to %1",
    "EVENT_WHENGREATERTHAN": "when %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "timer",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "loudness",
    "EVENT_BROADCAST": "broadcast %1",
    "EVENT_BROADCASTANDWAIT": "broadcast %1 and wait",
    "EVENT_WHENKEYPRESSED": "when %1 key pressed",
    "EVENT_WHENKEYPRESSED_SPACE": "space",
    "EVENT_WHENKEYPRESSED_LEFT": "left arrow",
    "EVENT_WHENKEYPRESSED_RIGHT": "right arrow",
    "EVENT_WHENKEYPRESSED_DOWN": "down arrow",
    "EVENT_WHENKEYPRESSED_UP": "up arrow",
    "EVENT_WHENKEYPRESSED_ANY": "any",
    "LOOKS_SAYFORSECS": "say %1 for %2 seconds",
    "LOOKS_SAY": "say %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "think %1 for %2 seconds",
    "LOOKS_THINK": "think %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "show",
    "LOOKS_HIDE": "hide",
    "LOOKS_HIDEALLSPRITES": "hide all sprites",
    "LOOKS_EFFECT_COLOR": "color",
    "LOOKS_EFFECT_FISHEYE": "fisheye",
    "LOOKS_EFFECT_WHIRL": "whirl",
    "LOOKS_EFFECT_PIXELATE": "pixelate",
    "LOOKS_EFFECT_MOSAIC": "mosaic",
    "LOOKS_EFFECT_BRIGHTNESS": "brightness",
    "LOOKS_EFFECT_GHOST": "ghost",
    "LOOKS_CHANGEEFFECTBY": "change %1 effect by %2",
    "LOOKS_SETEFFECTTO": "set %1 effect to %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "clear graphic effects",
    "LOOKS_CHANGESIZEBY": "change size by %1",
    "LOOKS_SETSIZETO": "set size to %1 %",
    "LOOKS_SIZE": "size",
    "LOOKS_CHANGESTRETCHBY": "change stretch by %1",
    "LOOKS_SETSTRETCHTO": "set stretch to %1 %",
    "LOOKS_SWITCHCOSTUMETO": "switch costume to %1",
    "LOOKS_NEXTCOSTUME": "next costume",
    "LOOKS_SWITCHBACKDROPTO": "switch backdrop to %1",
    "LOOKS_GOTOFRONTBACK": "go to %1 layer",
    "LOOKS_GOTOFRONTBACK_FRONT": "front",
    "LOOKS_GOTOFRONTBACK_BACK": "back",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "go %1 %2 layers",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "forward",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "backward",
    "LOOKS_BACKDROPNUMBERNAME": "backdrop %1",
    "LOOKS_COSTUMENUMBERNAME": "costume %1",
    "LOOKS_NUMBERNAME_NUMBER": "number",
    "LOOKS_NUMBERNAME_NAME": "name",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "switch backdrop to %1 and wait",
    "LOOKS_NEXTBACKDROP_BLOCK": "next backdrop",
    "LOOKS_NEXTBACKDROP": "next backdrop",
    "LOOKS_PREVIOUSBACKDROP": "previous backdrop",
    "LOOKS_RANDOMBACKDROP": "random backdrop",
    "MOTION_MOVESTEPS": "move %1 steps",
    "MOTION_TURNLEFT": "turn %1 %2 degrees",
    "MOTION_TURNRIGHT": "turn %1 %2 degrees",
    "MOTION_POINTINDIRECTION": "point in direction %1",
    "MOTION_POINTTOWARDS": "point towards %1",
    "MOTION_POINTTOWARDS_POINTER": "mouse-pointer",
    "MOTION_POINTTOWARDS_RANDOM": "random direction",
    "MOTION_GOTO": "go to %1",
    "MOTION_GOTO_POINTER": "mouse-pointer",
    "MOTION_GOTO_RANDOM": "random position",
    "MOTION_GOTOXY": "go to x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "glide %1 secs to x: %2 y: %3",
    "MOTION_GLIDETO": "glide %1 secs to %2",
    "MOTION_GLIDETO_POINTER": "mouse-pointer",
    "MOTION_GLIDETO_RANDOM": "random position",
    "MOTION_CHANGEXBY": "change x by %1",
    "MOTION_SETX": "set x to %1",
    "MOTION_CHANGEYBY": "change y by %1",
    "MOTION_SETY": "set y to %1",
    "MOTION_IFONEDGEBOUNCE": "if on edge, bounce",
    "MOTION_SETROTATIONSTYLE": "set rotation style %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "left-right",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "don't rotate",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "all around",
    "MOTION_XPOSITION": "x position",
    "MOTION_YPOSITION": "y position",
    "MOTION_DIRECTION": "direction",
    "MOTION_SCROLLRIGHT": "scroll right %1",
    "MOTION_SCROLLUP": "scroll up %1",
    "MOTION_ALIGNSCENE": "align scene %1",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "bottom-left",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "bottom-right",
    "MOTION_ALIGNSCENE_MIDDLE": "middle",
    "MOTION_ALIGNSCENE_TOPLEFT": "top-left",
    "MOTION_ALIGNSCENE_TOPRIGHT": "top-right",
    "MOTION_XSCROLL": "x scroll",
    "MOTION_YSCROLL": "y scroll",
    "MOTION_STAGE_SELECTED": "Stage selected: no motion blocks",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "pick random %1 to %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 and %2",
    "OPERATORS_OR": "%1 or %2",
    "OPERATORS_NOT": "not %1",
    "OPERATORS_JOIN": "join %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "letter %1 of %2",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "length of %1",
    "OPERATORS_CONTAINS": "%1 contains %2?",
    "OPERATORS_MOD": "%1 mod %2",
    "OPERATORS_ROUND": "round %1",
    "OPERATORS_MATHOP": "%1 of %2",
    "OPERATORS_MATHOP_ABS": "abs",
    "OPERATORS_MATHOP_FLOOR": "floor",
    "OPERATORS_MATHOP_CEILING": "ceiling",
    "OPERATORS_MATHOP_SQRT": "sqrt",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "define %1",
    "SENSING_TOUCHINGOBJECT": "touching %1?",
    "SENSING_TOUCHINGOBJECT_POINTER": "mouse-pointer",
    "SENSING_TOUCHINGOBJECT_EDGE": "edge",
    "SENSING_TOUCHINGCOLOR": "touching color %1?",
    "SENSING_COLORISTOUCHINGCOLOR": "color %1 is touching %2?",
    "SENSING_DISTANCETO": "distance to %1",
    "SENSING_DISTANCETO_POINTER": "mouse-pointer",
    "SENSING_ASKANDWAIT": "ask %1 and wait",
    "SENSING_ASK_TEXT": "What's your name?",
    "SENSING_ANSWER": "answer",
    "SENSING_KEYPRESSED": "key %1 pressed?",
    "SENSING_MOUSEDOWN": "mouse down?",
    "SENSING_MOUSEX": "mouse x",
    "SENSING_MOUSEY": "mouse y",
    "SENSING_SETDRAGMODE": "set drag mode %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "draggable",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "not draggable",
    "SENSING_LOUDNESS": "loudness",
    "SENSING_LOUD": "loud?",
    "SENSING_TIMER": "timer",
    "SENSING_RESETTIMER": "reset timer",
    "SENSING_OF": "%1 of %2",
    "SENSING_OF_XPOSITION": "x position",
    "SENSING_OF_YPOSITION": "y position",
    "SENSING_OF_DIRECTION": "direction",
    "SENSING_OF_COSTUMENUMBER": "costume #",
    "SENSING_OF_COSTUMENAME": "costume name",
    "SENSING_OF_SIZE": "size",
    "SENSING_OF_VOLUME": "volume",
    "SENSING_OF_BACKDROPNUMBER": "backdrop #",
    "SENSING_OF_BACKDROPNAME": "backdrop name",
    "SENSING_OF_STAGE": "Stage",
    "SENSING_CURRENT": "current %1",
    "SENSING_CURRENT_YEAR": "year",
    "SENSING_CURRENT_MONTH": "month",
    "SENSING_CURRENT_DATE": "date",
    "SENSING_CURRENT_DAYOFWEEK": "day of week",
    "SENSING_CURRENT_HOUR": "hour",
    "SENSING_CURRENT_MINUTE": "minute",
    "SENSING_CURRENT_SECOND": "second",
    "SENSING_DAYSSINCE2000": "days since 2000",
    "SENSING_USERNAME": "username",
    "SENSING_USERID": "user id",
    "SOUND_PLAY": "start sound %1",
    "SOUND_PLAYUNTILDONE": "play sound %1 until done",
    "SOUND_STOPALLSOUNDS": "stop all sounds",
    "SOUND_SETEFFECTO": "set %1 effect to %2",
    "SOUND_CHANGEEFFECTBY": "change %1 effect by %2",
    "SOUND_CLEAREFFECTS": "clear sound effects",
    "SOUND_EFFECTS_PITCH": "pitch",
    "SOUND_EFFECTS_PAN": "pan left/right",
    "SOUND_CHANGEVOLUMEBY": "change volume by %1",
    "SOUND_SETVOLUMETO": "set volume to %1%",
    "SOUND_VOLUME": "volume",
    "SOUND_RECORD": "record...",
    "CATEGORY_MOTION": "Motion",
    "CATEGORY_LOOKS": "Looks",
    "CATEGORY_SOUND": "Sound",
    "CATEGORY_EVENTS": "Events",
    "CATEGORY_CONTROL": "Control",
    "CATEGORY_SENSING": "Sensing",
    "CATEGORY_OPERATORS": "Operators",
    "CATEGORY_VARIABLES": "Variables",
    "CATEGORY_MYBLOCKS": "My Blocks",
    "DUPLICATE": "Duplicate",
    "DELETE": "Delete",
    "ADD_COMMENT": "Add Comment",
    "REMOVE_COMMENT": "Remove Comment",
    "DELETE_BLOCK": "Delete Block",
    "DELETE_X_BLOCKS": "Delete %1 Blocks",
    "DELETE_ALL_BLOCKS": "Delete all %1 blocks?",
    "CLEAN_UP": "Clean up Blocks",
    "HELP": "Help",
    "UNDO": "Undo",
    "REDO": "Redo",
    "EDIT_PROCEDURE": "Edit",
    "SHOW_PROCEDURE_DEFINITION": "Go to definition",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "Say something...",
    "COLOUR_HUE_LABEL": "Color",
    "COLOUR_SATURATION_LABEL": "Saturation",
    "COLOUR_BRIGHTNESS_LABEL": "Brightness",
    "CHANGE_VALUE_TITLE": "Change value:",
    "RENAME_VARIABLE": "Rename variable",
    "RENAME_VARIABLE_TITLE": "Rename all \"%1\" variables to:",
    "RENAME_VARIABLE_MODAL_TITLE": "Rename Variable",
    "NEW_VARIABLE": "Make a Variable",
    "NEW_VARIABLE_TITLE": "New variable name:",
    "VARIABLE_MODAL_TITLE": "New Variable",
    "VARIABLE_ALREADY_EXISTS": "A variable named \"%1\" already exists.",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "A variable named \"%1\" already exists for another variable of type \"%2\".",
    "DELETE_VARIABLE_CONFIRMATION": "Delete %1 uses of the \"%2\" variable?",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "Can't delete the variable \"%1\" because it's part of the definition of the function \"%2\"",
    "DELETE_VARIABLE": "Delete the \"%1\" variable",
    "NEW_PROCEDURE": "Make a Block",
    "PROCEDURE_ALREADY_EXISTS": "A procedure named \"%1\" already exists.",
    "PROCEDURE_DEFAULT_NAME": "block name",
    "PROCEDURE_USED": "To delete a block definition, first remove all uses of the block",
    "NEW_LIST": "Make a List",
    "NEW_LIST_TITLE": "New list name:",
    "LIST_MODAL_TITLE": "New List",
    "LIST_ALREADY_EXISTS": "A list named \"%1\" already exists.",
    "RENAME_LIST_TITLE": "Rename all \"%1\" lists to:",
    "RENAME_LIST_MODAL_TITLE": "Rename List",
    "DEFAULT_LIST_ITEM": "thing",
    "DELETE_LIST": "Delete the \"%1\" list",
    "RENAME_LIST": "Rename list",
    "NEW_BROADCAST_MESSAGE": "New message",
    "NEW_BROADCAST_MESSAGE_TITLE": "New message name:",
    "BROADCAST_MODAL_TITLE": "New Message",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
  },
  "zh-cn": {
    "CONTROL_FOREVER": "重复执行",
    "CONTROL_REPEAT": "重复执行 %1 次",
    "CONTROL_IF": "如果 %1 那么",
    "CONTROL_ELSE": "否则",
    "CONTROL_STOP": "停止",
    "CONTROL_STOP_ALL": "全部脚本",
    "CONTROL_STOP_THIS": "这个脚本",
    "CONTROL_STOP_OTHER": "该角色的其他脚本",
    "CONTROL_WAIT": "等待 %1 秒",
    "CONTROL_WAITUNTIL": "等待 %1",
    "CONTROL_REPEATUNTIL": "重复执行直到 %1",
    "CONTROL_WHILE": "当 %1 重复执行",
    "CONTROL_FOREACH": "对于 %2 中的每个 %1",
    "CONTROL_STARTASCLONE": "当作为克隆体启动时",
    "CONTROL_CREATECLONEOF": "克隆 %1",
    "CONTROL_CREATECLONEOF_MYSELF": "自己",
    "CONTROL_DELETETHISCLONE": "删除此克隆体",
    "CONTROL_COUNTER": "计数器",
    "CONTROL_INCRCOUNTER": "计数器加一",
    "CONTROL_CLEARCOUNTER": "计数器归零",
    "CONTROL_ALLATONCE": "所有脚本",
    "DATA_SETVARIABLETO": "将 %1 设为 %2",
    "DATA_CHANGEVARIABLEBY": "将 %1 增加 %2",
    "DATA_SHOWVARIABLE": "显示变量 %1",
    "DATA_HIDEVARIABLE": "隐藏变量 %1",
    "DATA_ADDTOLIST": "将 %1 加入 %2",
    "DATA_DELETEOFLIST": "删除 %2 的第 %1 项",
    "DATA_DELETEALLOFLIST": "删除 %1 的全部项目",
    "DATA_INSERTATLIST": "在 %3 的第 %2 项前插入 %1",
    "DATA_REPLACEITEMOFLIST": "将 %2 的第 %1 项替换为 %3",
    "DATA_ITEMOFLIST": "%2 的第 %1 项",
    "DATA_ITEMNUMOFLIST": "%2 中第一个 %1 的编号",
    "DATA_LENGTHOFLIST": "%1 的项目数",
    "DATA_LISTCONTAINSITEM": "%1 包含 %2 ?",
    "DATA_SHOWLIST": "显示列表 %1",
    "DATA_HIDELIST": "隐藏列表 %1",
    "DATA_INDEX_ALL": "全部",
    "DATA_INDEX_LAST": "末尾",
    "DATA_INDEX_RANDOM": "随机",
    "EVENT_WHENFLAGCLICKED": "当 %1 被点击",
    "EVENT_WHENTHISSPRITECLICKED": "当角色被点击",
    "EVENT_WHENSTAGECLICKED": "当舞台被点击",
    "EVENT_WHENTOUCHINGOBJECT": "当该角色碰到 %1",
    "EVENT_WHENBROADCASTRECEIVED": "当接收到 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "当背景换成 %1",
    "EVENT_WHENGREATERTHAN": "当 %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "计时器",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "响度",
    "EVENT_BROADCAST": "广播 %1",
    "EVENT_BROADCASTANDWAIT": "广播 %1 并等待",
    "EVENT_WHENKEYPRESSED": "当按下 %1 键",
    "EVENT_WHENKEYPRESSED_SPACE": "空格",
    "EVENT_WHENKEYPRESSED_LEFT": "←",
    "EVENT_WHENKEYPRESSED_RIGHT": "→",
    "EVENT_WHENKEYPRESSED_DOWN": "↓",
    "EVENT_WHENKEYPRESSED_UP": "↑",
    "EVENT_WHENKEYPRESSED_ANY": "任意",
    "LOOKS_SAYFORSECS": "说 %1 %2 秒",
    "LOOKS_SAY": "说 %1",
    "LOOKS_HELLO": "你好！",
    "LOOKS_THINKFORSECS": "思考 %1 %2 秒",
    "LOOKS_THINK": "思考 %1",
    "LOOKS_HMM": "嗯……",
    "LOOKS_SHOW": "显示",
    "LOOKS_HIDE": "隐藏",
    "LOOKS_HIDEALLSPRITES": "隐藏所有角色",
    "LOOKS_EFFECT_COLOR": "颜色",
    "LOOKS_EFFECT_FISHEYE": "鱼眼",
    "LOOKS_EFFECT_WHIRL": "漩涡",
    "LOOKS_EFFECT_PIXELATE": "像素化",
    "LOOKS_EFFECT_MOSAIC": "马赛克",
    "LOOKS_EFFECT_BRIGHTNESS": "亮度",
    "LOOKS_EFFECT_GHOST": "虚像",
    "LOOKS_CHANGEEFFECTBY": "将 %1 特效增加 %2",
    "LOOKS_SETEFFECTTO": "将 %1 特效设定为 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "清除图形特效",
    "LOOKS_CHANGESIZEBY": "将大小增加 %1",
    "LOOKS_SETSIZETO": "将大小设为 %1",
    "LOOKS_SIZE": "大小",
    "LOOKS_CHANGESTRETCHBY": "伸缩%1",
    "LOOKS_SETSTRETCHTO": "设置伸缩为%1 %",
    "LOOKS_SWITCHCOSTUMETO": "换成 %1 造型",
    "LOOKS_NEXTCOSTUME": "下一个造型",
    "LOOKS_SWITCHBACKDROPTO": "换成 %1 背景",
    "LOOKS_GOTOFRONTBACK": "移到最 %1 ",
    "LOOKS_GOTOFRONTBACK_FRONT": "前面",
    "LOOKS_GOTOFRONTBACK_BACK": "后面",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "%1 %2 层",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "前移",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "后移",
    "LOOKS_BACKDROPNUMBERNAME": "背景 %1",
    "LOOKS_COSTUMENUMBERNAME": "造型 %1",
    "LOOKS_NUMBERNAME_NUMBER": "编号",
    "LOOKS_NUMBERNAME_NAME": "名称",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "换成 %1 背景并等待",
    "LOOKS_NEXTBACKDROP_BLOCK": "下一个背景",
    "LOOKS_NEXTBACKDROP": "下一个背景",
    "LOOKS_PREVIOUSBACKDROP": "上一个背景",
    "LOOKS_RANDOMBACKDROP": "随机背景",
    "MOTION_MOVESTEPS": "移动 %1 步",
    "MOTION_TURNLEFT": "左转 %1 %2 度",
    "MOTION_TURNRIGHT": "右转 %1 %2 度",
    "MOTION_POINTINDIRECTION": "面向 %1 方向",
    "MOTION_POINTTOWARDS": "面向 %1",
    "MOTION_POINTTOWARDS_POINTER": "鼠标指针",
    "MOTION_POINTTOWARDS_RANDOM": "随机方向",
    "MOTION_GOTO": "移到 %1",
    "MOTION_GOTO_POINTER": "鼠标指针",
    "MOTION_GOTO_RANDOM": "随机位置",
    "MOTION_GOTOXY": "移到 x: %1 y: %2",
    "MOTION_GLIDESECSTOXY": "在 %1 秒内滑行到 x: %2 y: %3",
    "MOTION_GLIDETO": "在 %1 秒内滑行到 %2",
    "MOTION_GLIDETO_POINTER": "鼠标指针",
    "MOTION_GLIDETO_RANDOM": "随机位置",
    "MOTION_CHANGEXBY": "将x坐标增加 %1",
    "MOTION_SETX": "将x坐标设为 %1",
    "MOTION_CHANGEYBY": "将y坐标增加 %1",
    "MOTION_SETY": "将y坐标设为 %1",
    "MOTION_IFONEDGEBOUNCE": "碰到边缘就反弹",
    "MOTION_SETROTATIONSTYLE": "将旋转方式设为 %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左右翻转",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "不可旋转",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "任意旋转",
    "MOTION_XPOSITION": "x 坐标",
    "MOTION_YPOSITION": "y 坐标",
    "MOTION_DIRECTION": "方向",
    "MOTION_SCROLLRIGHT": "向右滚动 %1",
    "MOTION_SCROLLUP": "向上滚动 %1",
    "MOTION_ALIGNSCENE": "和场景 %1 对齐",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下角",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下角",
    "MOTION_ALIGNSCENE_MIDDLE": "中间",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上角",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上角",
    "MOTION_XSCROLL": "x滚动位置",
    "MOTION_YSCROLL": "y滚动位置",
    "MOTION_STAGE_SELECTED": "选中了舞台：不可使用运动类积木",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "在 %1 和 %2 之间取随机数",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 与 %2",
    "OPERATORS_OR": "%1 或 %2",
    "OPERATORS_NOT": "%1 不成立",
    "OPERATORS_JOIN": "连接 %1 和 %2",
    "OPERATORS_JOIN_APPLE": "苹果",
    "OPERATORS_JOIN_BANANA": "香蕉",
    "OPERATORS_LETTEROF": "%2 的第 %1 个字符",
    "OPERATORS_LETTEROF_APPLE": "果",
    "OPERATORS_LENGTH": "%1 的字符数",
    "OPERATORS_CONTAINS": "%1 包含 %2 ?",
    "OPERATORS_MOD": "%1 除以 %2 的余数",
    "OPERATORS_ROUND": "四舍五入 %1",
    "OPERATORS_MATHOP": "%1 %2",
    "OPERATORS_MATHOP_ABS": "绝对值",
    "OPERATORS_MATHOP_FLOOR": "向下取整",
    "OPERATORS_MATHOP_CEILING": "向上取整",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定义 %1",
    "SENSING_TOUCHINGOBJECT": "碰到 %1 ?",
    "SENSING_TOUCHINGOBJECT_POINTER": "鼠标指针",
    "SENSING_TOUCHINGOBJECT_EDGE": "舞台边缘",
    "SENSING_TOUCHINGCOLOR": "碰到颜色 %1 ?",
    "SENSING_COLORISTOUCHINGCOLOR": "颜色 %1 碰到 %2 ?",
    "SENSING_DISTANCETO": "到 %1 的距离",
    "SENSING_DISTANCETO_POINTER": "鼠标指针",
    "SENSING_ASKANDWAIT": "询问 %1 并等待",
    "SENSING_ASK_TEXT": "你叫什么名字？",
    "SENSING_ANSWER": "回答",
    "SENSING_KEYPRESSED": "按下 %1 键?",
    "SENSING_MOUSEDOWN": "按下鼠标?",
    "SENSING_MOUSEX": "鼠标的x坐标",
    "SENSING_MOUSEY": "鼠标的y坐标",
    "SENSING_SETDRAGMODE": "将拖动模式设为 %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "可拖动",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "不可拖动",
    "SENSING_LOUDNESS": "响度",
    "SENSING_LOUD": "响声？",
    "SENSING_TIMER": "计时器",
    "SENSING_RESETTIMER": "计时器归零",
    "SENSING_OF": "%2 的 %1",
    "SENSING_OF_XPOSITION": "x 坐标",
    "SENSING_OF_YPOSITION": "y 坐标",
    "SENSING_OF_DIRECTION": "方向",
    "SENSING_OF_COSTUMENUMBER": "造型编号",
    "SENSING_OF_COSTUMENAME": "造型名称",
    "SENSING_OF_SIZE": "大小",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景编号",
    "SENSING_OF_BACKDROPNAME": "背景名称",
    "SENSING_OF_STAGE": "舞台",
    "SENSING_CURRENT": "当前时间的 %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "星期",
    "SENSING_CURRENT_HOUR": "时",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年至今的天数",
    "SENSING_USERNAME": "用户名",
    "SENSING_USERID": "用户id",
    "SOUND_PLAY": "播放声音 %1",
    "SOUND_PLAYUNTILDONE": "播放声音 %1 等待播完",
    "SOUND_STOPALLSOUNDS": "停止所有声音",
    "SOUND_SETEFFECTO": "将 %1 音效设为 %2",
    "SOUND_CHANGEEFFECTBY": "将 %1 音效增加 %2",
    "SOUND_CLEAREFFECTS": "清除音效",
    "SOUND_EFFECTS_PITCH": "音调",
    "SOUND_EFFECTS_PAN": "左右平衡",
    "SOUND_CHANGEVOLUMEBY": "将音量增加 %1",
    "SOUND_SETVOLUMETO": "将音量设为 %1%",
    "SOUND_VOLUME": "音量",
    "SOUND_RECORD": "录制…",
    "CATEGORY_MOTION": "运动",
    "CATEGORY_LOOKS": "外观",
    "CATEGORY_SOUND": "声音",
    "CATEGORY_EVENTS": "事件",
    "CATEGORY_CONTROL": "控制",
    "CATEGORY_SENSING": "侦测",
    "CATEGORY_OPERATORS": "运算",
    "CATEGORY_VARIABLES": "变量",
    "CATEGORY_MYBLOCKS": "自制积木",
    "DUPLICATE": "复制",
    "DELETE": "删除",
    "ADD_COMMENT": "添加注释",
    "REMOVE_COMMENT": "删除注释",
    "DELETE_BLOCK": "删除",
    "DELETE_X_BLOCKS": "删除 %1 积木",
    "DELETE_ALL_BLOCKS": "删除全部 %1 积木？",
    "CLEAN_UP": "整理积木",
    "HELP": "帮助",
    "UNDO": "撤销",
    "REDO": "重做",
    "EDIT_PROCEDURE": "编辑",
    "SHOW_PROCEDURE_DEFINITION": "查看定义",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "说些什么……",
    "COLOUR_HUE_LABEL": "颜色",
    "COLOUR_SATURATION_LABEL": "饱和度",
    "COLOUR_BRIGHTNESS_LABEL": "亮度",
    "CHANGE_VALUE_TITLE": "更改变量：",
    "RENAME_VARIABLE": "修改变量名",
    "RENAME_VARIABLE_TITLE": "将所有的「%1」变量名改为：",
    "RENAME_VARIABLE_MODAL_TITLE": "修改变量名",
    "NEW_VARIABLE": "建立一个变量",
    "NEW_VARIABLE_TITLE": "新变量名：",
    "VARIABLE_MODAL_TITLE": "新建变量",
    "VARIABLE_ALREADY_EXISTS": "已经存在名为「%1」的变量。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "已经存在一个名为「%1」的变量，其类型为「%2」。",
    "DELETE_VARIABLE_CONFIRMATION": "删除%1处「%2」变量吗？",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "无法删除变量「%1」，因为函数「%2」的定义中用到了它",
    "DELETE_VARIABLE": "删除变量「%1」",
    "NEW_PROCEDURE": "制作新的积木",
    "PROCEDURE_ALREADY_EXISTS": "已经存在名为「%1」的程序。",
    "PROCEDURE_DEFAULT_NAME": "积木名称",
    "PROCEDURE_USED": "在删除一个积木定义前，请先把该积木从所有使用的地方删除。",
    "NEW_LIST": "建立一个列表",
    "NEW_LIST_TITLE": "新的列表名：",
    "LIST_MODAL_TITLE": "新建列表",
    "LIST_ALREADY_EXISTS": "名为 「%1」 的列表已存在。",
    "RENAME_LIST_TITLE": "将所有的「%1」列表改名为：",
    "RENAME_LIST_MODAL_TITLE": "修改列表名",
    "DEFAULT_LIST_ITEM": "东西",
    "DELETE_LIST": "删除「%1」列表",
    "RENAME_LIST": "修改列表名",
    "NEW_BROADCAST_MESSAGE": "新消息",
    "NEW_BROADCAST_MESSAGE_TITLE": "新消息的名称：",
    "BROADCAST_MODAL_TITLE": "新消息",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "消息1"
  },
  "zh-tw": {
    "CONTROL_FOREVER": "重複無限次",
    "CONTROL_REPEAT": "重複 %1 次",
    "CONTROL_IF": "如果 %1 那麼",
    "CONTROL_ELSE": "否則",
    "CONTROL_STOP": "停止",
    "CONTROL_STOP_ALL": "全部",
    "CONTROL_STOP_THIS": "這個程式",
    "CONTROL_STOP_OTHER": "這個物件的其它程式",
    "CONTROL_WAIT": "等待 %1 秒",
    "CONTROL_WAITUNTIL": "等待直到 %1",
    "CONTROL_REPEATUNTIL": "重複直到 %1",
    "CONTROL_WHILE": "當 %1",
    "CONTROL_FOREACH": "計數 %1 於 %2",
    "CONTROL_STARTASCLONE": "當分身產生",
    "CONTROL_CREATECLONEOF": "建立 %1 的分身",
    "CONTROL_CREATECLONEOF_MYSELF": "自己",
    "CONTROL_DELETETHISCLONE": "分身刪除",
    "CONTROL_COUNTER": "計數器",
    "CONTROL_INCRCOUNTER": "計數器累計",
    "CONTROL_CLEARCOUNTER": "計數器重置",
    "CONTROL_ALLATONCE": "全部一起",
    "DATA_SETVARIABLETO": "變數 %1 設為 %2",
    "DATA_CHANGEVARIABLEBY": "變數 %1 改變 %2",
    "DATA_SHOWVARIABLE": "變數 %1 顯示",
    "DATA_HIDEVARIABLE": "變數 %1 隱藏",
    "DATA_ADDTOLIST": "添加 %1 到 %2",
    "DATA_DELETEOFLIST": "刪除 %2 的第 %1 項",
    "DATA_DELETEALLOFLIST": "刪除 %1 的所有項目",
    "DATA_INSERTATLIST": "插入 %1 到 %3 的第 %2 項",
    "DATA_REPLACEITEMOFLIST": "替換 %2 的第 %1 項為 %3",
    "DATA_ITEMOFLIST": "%2 的第 %1 項",
    "DATA_ITEMNUMOFLIST": "%1 在 %2 裡的項目編號",
    "DATA_LENGTHOFLIST": "清單 %1 的長度",
    "DATA_LISTCONTAINSITEM": "清單 %1 包含 %2？",
    "DATA_SHOWLIST": "清單 %1 顯示",
    "DATA_HIDELIST": "清單 %1 隱藏",
    "DATA_INDEX_ALL": "全部",
    "DATA_INDEX_LAST": "末",
    "DATA_INDEX_RANDOM": "隨機",
    "EVENT_WHENFLAGCLICKED": "當 %1 被點擊",
    "EVENT_WHENTHISSPRITECLICKED": "當角色被點擊",
    "EVENT_WHENSTAGECLICKED": "當舞台被點擊",
    "EVENT_WHENTOUCHINGOBJECT": "當角色碰到 %1",
    "EVENT_WHENBROADCASTRECEIVED": "當收到訊息 %1",
    "EVENT_WHENBACKDROPSWITCHESTO": "當背景換成 %1",
    "EVENT_WHENGREATERTHAN": "當 %1 > %2",
    "EVENT_WHENGREATERTHAN_TIMER": "計時器",
    "EVENT_WHENGREATERTHAN_LOUDNESS": "聲音響度",
    "EVENT_BROADCAST": "廣播訊息 %1",
    "EVENT_BROADCASTANDWAIT": "廣播訊息 %1 並等待",
    "EVENT_WHENKEYPRESSED": "當 %1 鍵被按下",
    "EVENT_WHENKEYPRESSED_SPACE": "空白",
    "EVENT_WHENKEYPRESSED_LEFT": "向左",
    "EVENT_WHENKEYPRESSED_RIGHT": "向右",
    "EVENT_WHENKEYPRESSED_DOWN": "向下",
    "EVENT_WHENKEYPRESSED_UP": "向上",
    "EVENT_WHENKEYPRESSED_ANY": "任何",
    "LOOKS_SAYFORSECS": "說出 %1 持續 %2 秒",
    "LOOKS_SAY": "說出 %1",
    "LOOKS_HELLO": "Hello!",
    "LOOKS_THINKFORSECS": "想著 %1 持續 %2 秒",
    "LOOKS_THINK": "想著 %1",
    "LOOKS_HMM": "Hmm...",
    "LOOKS_SHOW": "顯示",
    "LOOKS_HIDE": "隱藏",
    "LOOKS_HIDEALLSPRITES": "隱藏所有角色",
    "LOOKS_EFFECT_COLOR": "顏色",
    "LOOKS_EFFECT_FISHEYE": "魚眼",
    "LOOKS_EFFECT_WHIRL": "漩渦",
    "LOOKS_EFFECT_PIXELATE": "像素化",
    "LOOKS_EFFECT_MOSAIC": "馬賽克",
    "LOOKS_EFFECT_BRIGHTNESS": "亮度",
    "LOOKS_EFFECT_GHOST": "幻影",
    "LOOKS_CHANGEEFFECTBY": "圖像效果 %1 改變 %2",
    "LOOKS_SETEFFECTTO": "圖像效果 %1 設為 %2",
    "LOOKS_CLEARGRAPHICEFFECTS": "圖像效果清除",
    "LOOKS_CHANGESIZEBY": "尺寸改變 %1",
    "LOOKS_SETSIZETO": "尺寸設為 %1 %",
    "LOOKS_SIZE": "尺寸",
    "LOOKS_CHANGESTRETCHBY": "伸縮改變 %1",
    "LOOKS_SETSTRETCHTO": "伸縮設為 %1 %",
    "LOOKS_SWITCHCOSTUMETO": "造型換成 %1",
    "LOOKS_NEXTCOSTUME": "造型換成下一個",
    "LOOKS_SWITCHBACKDROPTO": "背景換成 %1",
    "LOOKS_GOTOFRONTBACK": "圖層移到 %1 層",
    "LOOKS_GOTOFRONTBACK_FRONT": "最上",
    "LOOKS_GOTOFRONTBACK_BACK": "最下",
    "LOOKS_GOFORWARDBACKWARDLAYERS": "圖層 %1 移 %2 層",
    "LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD": "上",
    "LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD": "下",
    "LOOKS_BACKDROPNUMBERNAME": "背景 %1",
    "LOOKS_COSTUMENUMBERNAME": "造型 %1",
    "LOOKS_NUMBERNAME_NUMBER": "編號",
    "LOOKS_NUMBERNAME_NAME": "名稱",
    "LOOKS_SWITCHBACKDROPTOANDWAIT": "背景換成 %1 並等待",
    "LOOKS_NEXTBACKDROP_BLOCK": "背景換成下一個",
    "LOOKS_NEXTBACKDROP": "下一個背景",
    "LOOKS_PREVIOUSBACKDROP": "上一個背景",
    "LOOKS_RANDOMBACKDROP": "任一個背景",
    "MOTION_MOVESTEPS": "移動 %1 點",
    "MOTION_TURNLEFT": "左轉 %1 %2 度",
    "MOTION_TURNRIGHT": "右轉 %1 %2 度",
    "MOTION_POINTINDIRECTION": "面朝 %1 度",
    "MOTION_POINTTOWARDS": "面朝 %1 向",
    "MOTION_POINTTOWARDS_POINTER": "鼠標",
    "MOTION_POINTTOWARDS_RANDOM": "隨機",
    "MOTION_GOTO": "定位到 %1 位置",
    "MOTION_GOTO_POINTER": "鼠標",
    "MOTION_GOTO_RANDOM": "隨機",
    "MOTION_GOTOXY": "定位到 x:%1 y:%2",
    "MOTION_GLIDESECSTOXY": "滑行 %1 秒到 x:%2 y:%3",
    "MOTION_GLIDETO": "滑行 %1 秒到 %2 位置",
    "MOTION_GLIDETO_POINTER": "鼠標",
    "MOTION_GLIDETO_RANDOM": "隨機",
    "MOTION_CHANGEXBY": "x 改變 %1",
    "MOTION_SETX": "x 設為 %1",
    "MOTION_CHANGEYBY": "y 改變 %1",
    "MOTION_SETY": "y 設為 %1",
    "MOTION_IFONEDGEBOUNCE": "碰到邊緣就反彈",
    "MOTION_SETROTATIONSTYLE": "迴轉方式設為 %1",
    "MOTION_SETROTATIONSTYLE_LEFTRIGHT": "左-右",
    "MOTION_SETROTATIONSTYLE_DONTROTATE": "不旋轉",
    "MOTION_SETROTATIONSTYLE_ALLAROUND": "不設限",
    "MOTION_XPOSITION": "x 座標",
    "MOTION_YPOSITION": "y 座標",
    "MOTION_DIRECTION": "方向",
    "MOTION_SCROLLRIGHT": "滾動向右 %1",
    "MOTION_SCROLLUP": "滾動向上 %1",
    "MOTION_ALIGNSCENE": "場景 %1 對齊",
    "MOTION_ALIGNSCENE_BOTTOMLEFT": "左下",
    "MOTION_ALIGNSCENE_BOTTOMRIGHT": "右下",
    "MOTION_ALIGNSCENE_MIDDLE": "中間",
    "MOTION_ALIGNSCENE_TOPLEFT": "左上",
    "MOTION_ALIGNSCENE_TOPRIGHT": "右上",
    "MOTION_XSCROLL": "x 捲軸",
    "MOTION_YSCROLL": "y 捲軸",
    "MOTION_STAGE_SELECTED": "目前選擇的物件是「舞台」：無可用的動作積木",
    "OPERATORS_ADD": "%1 + %2",
    "OPERATORS_SUBTRACT": "%1 - %2",
    "OPERATORS_MULTIPLY": "%1 * %2",
    "OPERATORS_DIVIDE": "%1 / %2",
    "OPERATORS_RANDOM": "隨機取數 %1 到 %2",
    "OPERATORS_GT": "%1 > %2",
    "OPERATORS_LT": "%1 < %2",
    "OPERATORS_EQUALS": "%1 = %2",
    "OPERATORS_AND": "%1 且 %2",
    "OPERATORS_OR": "%1 或 %2",
    "OPERATORS_NOT": "%1 不成立",
    "OPERATORS_JOIN": "字串組合 %1 %2",
    "OPERATORS_JOIN_APPLE": "apple",
    "OPERATORS_JOIN_BANANA": "banana",
    "OPERATORS_LETTEROF": "字串 %2 的第 %1 字",
    "OPERATORS_LETTEROF_APPLE": "a",
    "OPERATORS_LENGTH": "字串 %1 的長度",
    "OPERATORS_CONTAINS": "字串 %1 包含 %2？",
    "OPERATORS_MOD": "%1 除以 %2 的餘數",
    "OPERATORS_ROUND": "四捨五入數值 %1",
    "OPERATORS_MATHOP": "%1 數值 %2",
    "OPERATORS_MATHOP_ABS": "絕對值",
    "OPERATORS_MATHOP_FLOOR": "無條件捨去",
    "OPERATORS_MATHOP_CEILING": "無條件進位",
    "OPERATORS_MATHOP_SQRT": "平方根",
    "OPERATORS_MATHOP_SIN": "sin",
    "OPERATORS_MATHOP_COS": "cos",
    "OPERATORS_MATHOP_TAN": "tan",
    "OPERATORS_MATHOP_ASIN": "asin",
    "OPERATORS_MATHOP_ACOS": "acos",
    "OPERATORS_MATHOP_ATAN": "atan",
    "OPERATORS_MATHOP_LN": "ln",
    "OPERATORS_MATHOP_LOG": "log",
    "OPERATORS_MATHOP_EEXP": "e ^",
    "OPERATORS_MATHOP_10EXP": "10 ^",
    "PROCEDURES_DEFINITION": "定義 %1",
    "SENSING_TOUCHINGOBJECT": "碰到 %1？",
    "SENSING_TOUCHINGOBJECT_POINTER": "鼠標",
    "SENSING_TOUCHINGOBJECT_EDGE": "邊緣",
    "SENSING_TOUCHINGCOLOR": "碰到顏色 %1？",
    "SENSING_COLORISTOUCHINGCOLOR": "顏色 %1 碰到 顏色 %2？",
    "SENSING_DISTANCETO": "與 %1 的間距",
    "SENSING_DISTANCETO_POINTER": "鼠標",
    "SENSING_ASKANDWAIT": "詢問 %1 並等待",
    "SENSING_ASK_TEXT": "你的名字是？",
    "SENSING_ANSWER": "詢問的答案",
    "SENSING_KEYPRESSED": "%1 鍵被按下？",
    "SENSING_MOUSEDOWN": "滑鼠鍵被按下？",
    "SENSING_MOUSEX": "鼠標的 x",
    "SENSING_MOUSEY": "鼠標的 y",
    "SENSING_SETDRAGMODE": "拖曳方式設為 %1",
    "SENSING_SETDRAGMODE_DRAGGABLE": "可拖曳",
    "SENSING_SETDRAGMODE_NOTDRAGGABLE": "不可拖曳",
    "SENSING_LOUDNESS": "聲音響度",
    "SENSING_LOUD": "大聲？",
    "SENSING_TIMER": "計時器",
    "SENSING_RESETTIMER": "計時器重置",
    "SENSING_OF": "%2 的 %1",
    "SENSING_OF_XPOSITION": "x 座標",
    "SENSING_OF_YPOSITION": "y 座標",
    "SENSING_OF_DIRECTION": "方向",
    "SENSING_OF_COSTUMENUMBER": "造型編號",
    "SENSING_OF_COSTUMENAME": "造型名稱",
    "SENSING_OF_SIZE": "尺寸",
    "SENSING_OF_VOLUME": "音量",
    "SENSING_OF_BACKDROPNUMBER": "背景編號",
    "SENSING_OF_BACKDROPNAME": "背景名稱",
    "SENSING_OF_STAGE": "舞台",
    "SENSING_CURRENT": "目前時間的 %1",
    "SENSING_CURRENT_YEAR": "年",
    "SENSING_CURRENT_MONTH": "月",
    "SENSING_CURRENT_DATE": "日",
    "SENSING_CURRENT_DAYOFWEEK": "週",
    "SENSING_CURRENT_HOUR": "時",
    "SENSING_CURRENT_MINUTE": "分",
    "SENSING_CURRENT_SECOND": "秒",
    "SENSING_DAYSSINCE2000": "2000年迄今日數",
    "SENSING_USERNAME": "用戶名稱",
    "SENSING_USERID": "用戶 ID",
    "SOUND_PLAY": "播放音效 %1",
    "SOUND_PLAYUNTILDONE": "播放音效 %1 直到結束",
    "SOUND_STOPALLSOUNDS": "停播所有音效",
    "SOUND_SETEFFECTO": "聲音效果 %1 設為 %2",
    "SOUND_CHANGEEFFECTBY": "聲音效果 %1 改變 %2",
    "SOUND_CLEAREFFECTS": "聲音效果清除",
    "SOUND_EFFECTS_PITCH": "音高",
    "SOUND_EFFECTS_PAN": "聲道左/右",
    "SOUND_CHANGEVOLUMEBY": "音量改變 %1",
    "SOUND_SETVOLUMETO": "音量設為 %1%",
    "SOUND_VOLUME": "音量",
    "SOUND_RECORD": "錄音…",
    "CATEGORY_MOTION": "動作",
    "CATEGORY_LOOKS": "外觀",
    "CATEGORY_SOUND": "音效",
    "CATEGORY_EVENTS": "事件",
    "CATEGORY_CONTROL": "控制",
    "CATEGORY_SENSING": "偵測",
    "CATEGORY_OPERATORS": "運算",
    "CATEGORY_VARIABLES": "變數",
    "CATEGORY_MYBLOCKS": "函式積木",
    "DUPLICATE": "複製",
    "DELETE": "刪除",
    "ADD_COMMENT": "添加註解",
    "REMOVE_COMMENT": "移除註解",
    "DELETE_BLOCK": "刪除積木",
    "DELETE_X_BLOCKS": "刪除 %1 個積木",
    "DELETE_ALL_BLOCKS": "要刪除全部（%1 個）積木？",
    "CLEAN_UP": "整理積木",
    "HELP": "幫助",
    "UNDO": "復原",
    "REDO": "重做",
    "EDIT_PROCEDURE": "編輯",
    "SHOW_PROCEDURE_DEFINITION": "移至定義",
    "WORKSPACE_COMMENT_DEFAULT_TEXT": "說些什麼…",
    "COLOUR_HUE_LABEL": "顏色",
    "COLOUR_SATURATION_LABEL": "彩度",
    "COLOUR_BRIGHTNESS_LABEL": "亮度",
    "CHANGE_VALUE_TITLE": "改成：",
    "RENAME_VARIABLE": "重新命名變數",
    "RENAME_VARIABLE_TITLE": "將變數「%1」重新命名為：",
    "RENAME_VARIABLE_MODAL_TITLE": "重新命名變數",
    "NEW_VARIABLE": "建立一個變數",
    "NEW_VARIABLE_TITLE": "新變數的名稱",
    "VARIABLE_MODAL_TITLE": "新的變數",
    "VARIABLE_ALREADY_EXISTS": "變數名稱「%1」已經被使用。",
    "VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE": "變數名稱「%1」已經被使用在「%2」型別了。",
    "DELETE_VARIABLE_CONFIRMATION": "刪除正在使用的變數「%2」的 %1 個地方？",
    "CANNOT_DELETE_VARIABLE_PROCEDURE": "無法刪除變數「%1」，因為它是函式「%2」定義中的一部分。",
    "DELETE_VARIABLE": "刪除變數「%1」",
    "NEW_PROCEDURE": "建立一個積木",
    "PROCEDURE_ALREADY_EXISTS": "程序名稱「%1」已經被使用。",
    "PROCEDURE_DEFAULT_NAME": "積木名稱",
    "PROCEDURE_USED": "刪除某個積木的定義之前，要先把正在使用中的先移除",
    "NEW_LIST": "建立一個清單",
    "NEW_LIST_TITLE": "新清單的名稱",
    "LIST_MODAL_TITLE": "新的清單",
    "LIST_ALREADY_EXISTS": "清單名稱「%1」已經被使用。",
    "RENAME_LIST_TITLE": "將清單「%1」重新命名為：",
    "RENAME_LIST_MODAL_TITLE": "重新命名清單",
    "DEFAULT_LIST_ITEM": "thing",
    "DELETE_LIST": "刪除清單「%1」",
    "RENAME_LIST": "重新命名清單",
    "NEW_BROADCAST_MESSAGE": "新的訊息",
    "NEW_BROADCAST_MESSAGE_TITLE": "新訊息的名稱",
    "BROADCAST_MODAL_TITLE": "新的訊息",
    "DEFAULT_BROADCAST_MESSAGE_NAME": "message1"
  }
};
const Blockly = {Msg: Object.create(null)};
/**
 * @license
 * Visual Blocks Language
 *
 * Copyright 2012 Google Inc.
 * https://developers.google.com/blockly/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview English strings.
 * @author ascii@media.mit.edu (Andrew Sliwinski)
 *
 * After modifying this file, run `npm run translate` from the root directory
 * to regenerate `./msg/json/en.json`.
 * IMPORTANT:
 * All message strings must use single quotes for the scripts to work properly
 */

'use strict';

// Control blocks
Blockly.Msg.CONTROL_FOREVER = 'forever';
Blockly.Msg.CONTROL_REPEAT = 'repeat %1';
Blockly.Msg.CONTROL_IF = 'if %1 then';
Blockly.Msg.CONTROL_ELSE = 'else';
Blockly.Msg.CONTROL_STOP = 'stop';
Blockly.Msg.CONTROL_STOP_ALL = 'all';
Blockly.Msg.CONTROL_STOP_THIS = 'this script';
Blockly.Msg.CONTROL_STOP_OTHER = 'other scripts in sprite';
Blockly.Msg.CONTROL_WAIT = 'wait %1 seconds';
Blockly.Msg.CONTROL_WAITUNTIL = 'wait until %1';
Blockly.Msg.CONTROL_REPEATUNTIL = 'repeat until %1';
Blockly.Msg.CONTROL_WHILE = 'while %1';
Blockly.Msg.CONTROL_FOREACH = 'for each %1 in %2';
Blockly.Msg.CONTROL_STARTASCLONE = 'when I start as a clone';
Blockly.Msg.CONTROL_CREATECLONEOF = 'create clone of %1';
Blockly.Msg.CONTROL_CREATECLONEOF_MYSELF = 'myself';
Blockly.Msg.CONTROL_DELETETHISCLONE = 'delete this clone';
Blockly.Msg.CONTROL_COUNTER = 'counter';
Blockly.Msg.CONTROL_INCRCOUNTER = 'increment counter';
Blockly.Msg.CONTROL_CLEARCOUNTER = 'clear counter';
Blockly.Msg.CONTROL_ALLATONCE = 'all at once';

// Data blocks
Blockly.Msg.DATA_SETVARIABLETO = 'set %1 to %2';
Blockly.Msg.DATA_CHANGEVARIABLEBY = 'change %1 by %2';
Blockly.Msg.DATA_SHOWVARIABLE = 'show variable %1';
Blockly.Msg.DATA_HIDEVARIABLE = 'hide variable %1';
Blockly.Msg.DATA_ADDTOLIST = 'add %1 to %2';
Blockly.Msg.DATA_DELETEOFLIST = 'delete %1 of %2';
Blockly.Msg.DATA_DELETEALLOFLIST = 'delete all of %1';
Blockly.Msg.DATA_INSERTATLIST = 'insert %1 at %2 of %3';
Blockly.Msg.DATA_REPLACEITEMOFLIST = 'replace item %1 of %2 with %3';
Blockly.Msg.DATA_ITEMOFLIST = 'item %1 of %2';
Blockly.Msg.DATA_ITEMNUMOFLIST = 'item # of %1 in %2';
Blockly.Msg.DATA_LENGTHOFLIST = 'length of %1';
Blockly.Msg.DATA_LISTCONTAINSITEM = '%1 contains %2?';
Blockly.Msg.DATA_SHOWLIST = 'show list %1';
Blockly.Msg.DATA_HIDELIST = 'hide list %1';
Blockly.Msg.DATA_INDEX_ALL = 'all';
Blockly.Msg.DATA_INDEX_LAST = 'last';
Blockly.Msg.DATA_INDEX_RANDOM = 'random';

// Event blocks
Blockly.Msg.EVENT_WHENFLAGCLICKED = 'when %1 clicked';
Blockly.Msg.EVENT_WHENTHISSPRITECLICKED = 'when this sprite clicked';
Blockly.Msg.EVENT_WHENSTAGECLICKED = 'when stage clicked';
Blockly.Msg.EVENT_WHENTOUCHINGOBJECT = 'when this sprite touches %1';
Blockly.Msg.EVENT_WHENBROADCASTRECEIVED = 'when I receive %1';
Blockly.Msg.EVENT_WHENBACKDROPSWITCHESTO = 'when backdrop switches to %1';
Blockly.Msg.EVENT_WHENGREATERTHAN = 'when %1 > %2';
Blockly.Msg.EVENT_WHENGREATERTHAN_TIMER = 'timer';
Blockly.Msg.EVENT_WHENGREATERTHAN_LOUDNESS = 'loudness';
Blockly.Msg.EVENT_BROADCAST = 'broadcast %1';
Blockly.Msg.EVENT_BROADCASTANDWAIT = 'broadcast %1 and wait';
Blockly.Msg.EVENT_WHENKEYPRESSED = 'when %1 key pressed';
Blockly.Msg.EVENT_WHENKEYPRESSED_SPACE = 'space';
Blockly.Msg.EVENT_WHENKEYPRESSED_LEFT = 'left arrow';
Blockly.Msg.EVENT_WHENKEYPRESSED_RIGHT = 'right arrow';
Blockly.Msg.EVENT_WHENKEYPRESSED_DOWN = 'down arrow';
Blockly.Msg.EVENT_WHENKEYPRESSED_UP = 'up arrow';
Blockly.Msg.EVENT_WHENKEYPRESSED_ANY = 'any';
Blockly.Msg.EVENT_WHENKEYPRESSED_ENTER = 'enter';

// Looks blocks
Blockly.Msg.LOOKS_SAYFORSECS = 'say %1 for %2 seconds';
Blockly.Msg.LOOKS_SAY = 'say %1';
Blockly.Msg.LOOKS_HELLO = 'Hello!';
Blockly.Msg.LOOKS_THINKFORSECS = 'think %1 for %2 seconds';
Blockly.Msg.LOOKS_THINK = 'think %1';
Blockly.Msg.LOOKS_HMM = 'Hmm...';
Blockly.Msg.LOOKS_SHOW = 'show';
Blockly.Msg.LOOKS_HIDE = 'hide';
Blockly.Msg.LOOKS_HIDEALLSPRITES = 'hide all sprites';
Blockly.Msg.LOOKS_EFFECT_COLOR = 'color';
Blockly.Msg.LOOKS_EFFECT_FISHEYE = 'fisheye';
Blockly.Msg.LOOKS_EFFECT_WHIRL = 'whirl';
Blockly.Msg.LOOKS_EFFECT_PIXELATE = 'pixelate';
Blockly.Msg.LOOKS_EFFECT_MOSAIC = 'mosaic';
Blockly.Msg.LOOKS_EFFECT_BRIGHTNESS = 'brightness';
Blockly.Msg.LOOKS_EFFECT_GHOST = 'ghost';
Blockly.Msg.LOOKS_CHANGEEFFECTBY = 'change %1 effect by %2';
Blockly.Msg.LOOKS_SETEFFECTTO = 'set %1 effect to %2';
Blockly.Msg.LOOKS_CLEARGRAPHICEFFECTS = 'clear graphic effects';
Blockly.Msg.LOOKS_CHANGESIZEBY = 'change size by %1';
Blockly.Msg.LOOKS_SETSIZETO = 'set size to %1 %';
Blockly.Msg.LOOKS_SIZE = 'size';
Blockly.Msg.LOOKS_CHANGESTRETCHBY = 'change stretch by %1';
Blockly.Msg.LOOKS_SETSTRETCHTO = 'set stretch to %1 %';
Blockly.Msg.LOOKS_SWITCHCOSTUMETO = 'switch costume to %1';
Blockly.Msg.LOOKS_NEXTCOSTUME = 'next costume';
Blockly.Msg.LOOKS_SWITCHBACKDROPTO = 'switch backdrop to %1';
Blockly.Msg.LOOKS_GOTOFRONTBACK = 'go to %1 layer';
Blockly.Msg.LOOKS_GOTOFRONTBACK_FRONT = 'front';
Blockly.Msg.LOOKS_GOTOFRONTBACK_BACK = 'back';
Blockly.Msg.LOOKS_GOFORWARDBACKWARDLAYERS = 'go %1 %2 layers';
Blockly.Msg.LOOKS_GOFORWARDBACKWARDLAYERS_FORWARD = 'forward';
Blockly.Msg.LOOKS_GOFORWARDBACKWARDLAYERS_BACKWARD = 'backward';
Blockly.Msg.LOOKS_BACKDROPNUMBERNAME = 'backdrop %1';
Blockly.Msg.LOOKS_COSTUMENUMBERNAME = 'costume %1';
Blockly.Msg.LOOKS_NUMBERNAME_NUMBER = 'number';
Blockly.Msg.LOOKS_NUMBERNAME_NAME = 'name';
Blockly.Msg.LOOKS_SWITCHBACKDROPTOANDWAIT = 'switch backdrop to %1 and wait';
Blockly.Msg.LOOKS_NEXTBACKDROP_BLOCK = 'next backdrop';
Blockly.Msg.LOOKS_NEXTBACKDROP = 'next backdrop';
Blockly.Msg.LOOKS_PREVIOUSBACKDROP = 'previous backdrop';
Blockly.Msg.LOOKS_RANDOMBACKDROP = 'random backdrop';

// Motion blocks
Blockly.Msg.MOTION_MOVESTEPS = 'move %1 steps';
Blockly.Msg.MOTION_TURNLEFT = 'turn %1 %2 degrees';
Blockly.Msg.MOTION_TURNRIGHT = 'turn %1 %2 degrees';
Blockly.Msg.MOTION_POINTINDIRECTION = 'point in direction %1';
Blockly.Msg.MOTION_POINTTOWARDS = 'point towards %1';
Blockly.Msg.MOTION_POINTTOWARDS_POINTER = 'mouse-pointer';
Blockly.Msg.MOTION_POINTTOWARDS_RANDOM = 'random direction';
Blockly.Msg.MOTION_GOTO = 'go to %1';
Blockly.Msg.MOTION_GOTO_POINTER = 'mouse-pointer';
Blockly.Msg.MOTION_GOTO_RANDOM = 'random position';
Blockly.Msg.MOTION_GOTOXY = 'go to x: %1 y: %2';
Blockly.Msg.MOTION_GLIDESECSTOXY = 'glide %1 secs to x: %2 y: %3';
Blockly.Msg.MOTION_GLIDETO = 'glide %1 secs to %2';
Blockly.Msg.MOTION_GLIDETO_POINTER = 'mouse-pointer';
Blockly.Msg.MOTION_GLIDETO_RANDOM = 'random position';
Blockly.Msg.MOTION_CHANGEXBY = 'change x by %1';
Blockly.Msg.MOTION_SETX = 'set x to %1';
Blockly.Msg.MOTION_CHANGEYBY = 'change y by %1';
Blockly.Msg.MOTION_SETY = 'set y to %1';
Blockly.Msg.MOTION_IFONEDGEBOUNCE = 'if on edge, bounce';
Blockly.Msg.MOTION_SETROTATIONSTYLE = 'set rotation style %1';
Blockly.Msg.MOTION_SETROTATIONSTYLE_LEFTRIGHT = 'left-right';
Blockly.Msg.MOTION_SETROTATIONSTYLE_DONTROTATE = 'don\'t rotate';
Blockly.Msg.MOTION_SETROTATIONSTYLE_ALLAROUND = 'all around';
Blockly.Msg.MOTION_XPOSITION = 'x position';
Blockly.Msg.MOTION_YPOSITION = 'y position';
Blockly.Msg.MOTION_DIRECTION = 'direction';
Blockly.Msg.MOTION_SCROLLRIGHT = 'scroll right %1';
Blockly.Msg.MOTION_SCROLLUP = 'scroll up %1';
Blockly.Msg.MOTION_ALIGNSCENE = 'align scene %1';
Blockly.Msg.MOTION_ALIGNSCENE_BOTTOMLEFT = 'bottom-left';
Blockly.Msg.MOTION_ALIGNSCENE_BOTTOMRIGHT = 'bottom-right';
Blockly.Msg.MOTION_ALIGNSCENE_MIDDLE = 'middle';
Blockly.Msg.MOTION_ALIGNSCENE_TOPLEFT = 'top-left';
Blockly.Msg.MOTION_ALIGNSCENE_TOPRIGHT = 'top-right';
Blockly.Msg.MOTION_XSCROLL = 'x scroll';
Blockly.Msg.MOTION_YSCROLL = 'y scroll';
Blockly.Msg.MOTION_STAGE_SELECTED = 'Stage selected: no motion blocks';

// Operators blocks
Blockly.Msg.OPERATORS_ADD = '%1 + %2';
Blockly.Msg.OPERATORS_SUBTRACT = '%1 - %2';
Blockly.Msg.OPERATORS_MULTIPLY = '%1 * %2';
Blockly.Msg.OPERATORS_DIVIDE = '%1 / %2';
Blockly.Msg.OPERATORS_RANDOM = 'pick random %1 to %2';
Blockly.Msg.OPERATORS_GT = '%1 > %2';
Blockly.Msg.OPERATORS_LT = '%1 < %2';
Blockly.Msg.OPERATORS_EQUALS = '%1 = %2';
Blockly.Msg.OPERATORS_AND = '%1 and %2';
Blockly.Msg.OPERATORS_OR = '%1 or %2';
Blockly.Msg.OPERATORS_NOT = 'not %1';
Blockly.Msg.OPERATORS_JOIN = 'join %1 %2';
Blockly.Msg.OPERATORS_JOIN_APPLE = 'apple';
Blockly.Msg.OPERATORS_JOIN_BANANA = 'banana';
Blockly.Msg.OPERATORS_JOIN_MULTIPLE = 'join';
Blockly.Msg.OPERATORS_LETTEROF = 'letter %1 of %2';
Blockly.Msg.OPERATORS_LETTEROF_APPLE = 'a';
Blockly.Msg.OPERATORS_LENGTH = 'length of %1';
Blockly.Msg.OPERATORS_CONTAINS = '%1 contains %2?';
Blockly.Msg.OPERATORS_MOD = '%1 mod %2';
Blockly.Msg.OPERATORS_ROUND = 'round %1';
Blockly.Msg.OPERATORS_MATHOP = '%1 of %2';
Blockly.Msg.OPERATORS_MATHOP_ABS = 'abs';
Blockly.Msg.OPERATORS_MATHOP_FLOOR = 'floor';
Blockly.Msg.OPERATORS_MATHOP_CEILING = 'ceiling';
Blockly.Msg.OPERATORS_MATHOP_SQRT = 'sqrt';
Blockly.Msg.OPERATORS_MATHOP_SIN = 'sin';
Blockly.Msg.OPERATORS_MATHOP_COS = 'cos';
Blockly.Msg.OPERATORS_MATHOP_TAN = 'tan';
Blockly.Msg.OPERATORS_MATHOP_ASIN = 'asin';
Blockly.Msg.OPERATORS_MATHOP_ACOS = 'acos';
Blockly.Msg.OPERATORS_MATHOP_ATAN = 'atan';
Blockly.Msg.OPERATORS_MATHOP_LN = 'ln';
Blockly.Msg.OPERATORS_MATHOP_LOG = 'log';
Blockly.Msg.OPERATORS_MATHOP_EEXP = 'e ^';
Blockly.Msg.OPERATORS_MATHOP_10EXP = '10 ^';
Blockly.Msg.OPERATORS_POWER = '%1 ^ %2';
Blockly.Msg.OPERATORS_BITAND = '%1 & %2';
Blockly.Msg.OPERATORS_BITOR = '%1 | %2';
Blockly.Msg.OPERATORS_BITXOR = '%1 xor %2';
Blockly.Msg.OPERATORS_BITNOT = '~ %1';
Blockly.Msg.OPERATORS_BITLSH = '%1 << %2';
Blockly.Msg.OPERATORS_BITRSH = '%1 >> %2';
Blockly.Msg.OPERATORS_BITURSH = '%1 >>> %2';
Blockly.Msg.OPERATORS_GE = '%1 ≥ %2';
Blockly.Msg.OPERATORS_LE = '%1 ≤ %2';
Blockly.Msg.OPERATORS_NEQUALS = '%1 ≠ %2';
Blockly.Msg.OPERATORS_INDEXOF = 'position %1 of %2 contain %3';

// Procedures blocks
Blockly.Msg.PROCEDURES_DEFINITION = 'define %1';
Blockly.Msg.PROCEDURES_RETURN = 'return %1';

// Sensing blocks
Blockly.Msg.SENSING_TOUCHINGOBJECT = 'touching %1?';
Blockly.Msg.SENSING_TOUCHINGOBJECT_POINTER = 'mouse-pointer';
Blockly.Msg.SENSING_TOUCHINGOBJECT_EDGE = 'edge';
Blockly.Msg.SENSING_TOUCHINGCOLOR = 'touching color %1?';
Blockly.Msg.SENSING_COLORISTOUCHINGCOLOR = 'color %1 is touching %2?';
Blockly.Msg.SENSING_DISTANCETO = 'distance to %1';
Blockly.Msg.SENSING_DISTANCETO_POINTER = 'mouse-pointer';
Blockly.Msg.SENSING_DISTANCEBETWEENPOSITION = 'distance from (x: %1, y: %2 ) to (x: %3 , y: %4 )';
Blockly.Msg.SENSING_DIRECTIONBETWEENPOSITION = 'direction from (x: %1, y: %2 ) to (x: %3 , y: %4 )';
Blockly.Msg.SENSING_ASKANDWAIT = 'ask %1 and wait';
Blockly.Msg.SENSING_ASK_TEXT = 'What\'s your name?';
Blockly.Msg.SENSING_ANSWER = 'answer';
Blockly.Msg.SENSING_KEYPRESSED = 'key %1 pressed?';
Blockly.Msg.SENSING_MOUSEDOWN = 'mouse down?';
Blockly.Msg.SENSING_MOUSEPRESSED = 'mouse %1 pressed?';
Blockly.Msg.SENSING_MOUSEPRESSED_LEFT = 'left';
Blockly.Msg.SENSING_MOUSEPRESSED_MIDDLE = 'middle';
Blockly.Msg.SENSING_MOUSEPRESSED_RIGHT = 'right';
Blockly.Msg.SENSING_MOUSEX = 'mouse x';
Blockly.Msg.SENSING_MOUSEY = 'mouse y';
Blockly.Msg.SENSING_SETDRAGMODE = 'set drag mode %1';
Blockly.Msg.SENSING_SETDRAGMODE_DRAGGABLE = 'draggable';
Blockly.Msg.SENSING_SETDRAGMODE_NOTDRAGGABLE = 'not draggable';
Blockly.Msg.SENSING_LOUDNESS = 'loudness';
Blockly.Msg.SENSING_LOUD = 'loud?';
Blockly.Msg.SENSING_TIMER = 'timer';
Blockly.Msg.SENSING_RESETTIMER = 'reset timer';
Blockly.Msg.SENSING_OF = '%1 of %2';
Blockly.Msg.SENSING_OF_XPOSITION = 'x position';
Blockly.Msg.SENSING_OF_YPOSITION = 'y position';
Blockly.Msg.SENSING_OF_DIRECTION = 'direction';
Blockly.Msg.SENSING_OF_COSTUMENUMBER = 'costume #';
Blockly.Msg.SENSING_OF_COSTUMENAME = 'costume name';
Blockly.Msg.SENSING_OF_SIZE = 'size';
Blockly.Msg.SENSING_OF_VOLUME = 'volume';
Blockly.Msg.SENSING_OF_BACKDROPNUMBER = 'backdrop #';
Blockly.Msg.SENSING_OF_BACKDROPNAME = 'backdrop name';
Blockly.Msg.SENSING_OF_STAGE = 'Stage';
Blockly.Msg.SENSING_CURRENT = 'current %1';
Blockly.Msg.SENSING_CURRENT_YEAR = 'year';
Blockly.Msg.SENSING_CURRENT_MONTH = 'month';
Blockly.Msg.SENSING_CURRENT_DATE = 'date';
Blockly.Msg.SENSING_CURRENT_DAYOFWEEK = 'day of week';
Blockly.Msg.SENSING_CURRENT_HOUR = 'hour';
Blockly.Msg.SENSING_CURRENT_MINUTE = 'minute';
Blockly.Msg.SENSING_CURRENT_SECOND = 'second';
Blockly.Msg.SENSING_DAYSSINCE2000 = 'days since 2000';
Blockly.Msg.SENSING_USERNAME = 'username';
Blockly.Msg.SENSING_USERID = 'user id';
Blockly.Msg.SENSING_COLORAT = 'get the color at (x: %1, y: %2)';
Blockly.Msg.SENSING_OPERATINGSYSTEM = 'operating system';
Blockly.Msg.SENSING_CLIPCC_VERSION = 'ClipCC version';
Blockly.Msg.SENSING_JOYSTICKX = 'joystick x axis';
Blockly.Msg.SENSING_JOYSTICKY = 'joystick y axis';
Blockly.Msg.SENSING_JOYSTICK_DISTANCE = 'joystick distance';
Blockly.Msg.SENSING_TURNONTURBOMODE = 'turn on turbo mode';
Blockly.Msg.SENSING_TURNOFFTURBOMODE = 'turn off turbo mode';
Blockly.Msg.SENSING_ISTURBOMODE = 'turbo mode?';

// Sound blocks
Blockly.Msg.SOUND_PLAY = 'start sound %1';
Blockly.Msg.SOUND_PLAYUNTILDONE = 'play sound %1 until done';
Blockly.Msg.SOUND_STOPALLSOUNDS = 'stop all sounds';
Blockly.Msg.SOUND_SETEFFECTO = 'set %1 effect to %2';
Blockly.Msg.SOUND_CHANGEEFFECTBY = 'change %1 effect by %2';
Blockly.Msg.SOUND_CLEAREFFECTS = 'clear sound effects';
Blockly.Msg.SOUND_EFFECTS_PITCH = 'pitch';
Blockly.Msg.SOUND_EFFECTS_PAN = 'pan left/right';
Blockly.Msg.SOUND_CHANGEVOLUMEBY = 'change volume by %1';
Blockly.Msg.SOUND_SETVOLUMETO = 'set volume to %1%';
Blockly.Msg.SOUND_VOLUME = 'volume';
Blockly.Msg.SOUND_RECORD = 'record...';

// Category labels
Blockly.Msg.CATEGORY_MOTION = 'Motion';
Blockly.Msg.CATEGORY_LOOKS = 'Looks';
Blockly.Msg.CATEGORY_SOUND = 'Sound';
Blockly.Msg.CATEGORY_EVENTS = 'Events';
Blockly.Msg.CATEGORY_CONTROL = 'Control';
Blockly.Msg.CATEGORY_SENSING = 'Sensing';
Blockly.Msg.CATEGORY_OPERATORS = 'Operators';
Blockly.Msg.CATEGORY_VARIABLES = 'Variables';
Blockly.Msg.CATEGORY_MYBLOCKS = 'Functions';

// Context menus
Blockly.Msg.DUPLICATE_BLOCK = 'Duplicate';
Blockly.Msg.ADD_COMMENT = 'Add Comment';
Blockly.Msg.DUPLICATE_COMMENT = 'Duplicate Comment';
Blockly.Msg.REMOVE_COMMENT = 'Remove Comment';
Blockly.Msg.COLLAPSE_ALL = 'Collapse Blocks';
Blockly.Msg.COLLAPSE_BLOCK = 'Collapse Block';
Blockly.Msg.EXPAND_ALL = 'Expand Blocks';
Blockly.Msg.EXPAND_BLOCK = 'Expand Block';
Blockly.Msg.DISABLE_BLOCK = 'Disable Block';
Blockly.Msg.ENABLE_BLOCK = 'Enable Block';
Blockly.Msg.DELETE_BLOCK = 'Delete Block';
Blockly.Msg.DELETE_X_BLOCKS = 'Delete %1 Blocks';
Blockly.Msg.DELETE_ALL_BLOCKS = 'Delete all %1 blocks?';
Blockly.Msg.CLEAN_UP = 'Clean up Blocks';
Blockly.Msg.HELP = 'Help';
Blockly.Msg.UNDO = 'Undo';
Blockly.Msg.REDO = 'Redo';
Blockly.Msg.EDIT_PROCEDURE = 'Edit';
Blockly.Msg.CHANGE_PROCEDURE_SHAPE = 'Change Shape';
Blockly.Msg.SHOW_PROCEDURE_DEFINITION = 'Go to definition';
Blockly.Msg.WORKSPACE_COMMENT_DEFAULT_TEXT = 'Say something...';
Blockly.Msg.COPY = 'Copy to Clipboard';
Blockly.Msg.PASTE = 'Paste';
Blockly.Msg.PASTE_ERROR = 'Clipboard content is not valid block data and cannot be pasted.';
Blockly.Msg.INSERT_INPUT = 'Insert an Input';
Blockly.Msg.DELETE_INPUT = 'Delete the Input';

// Color
Blockly.Msg.COLOUR_HUE_LABEL = 'Color';
Blockly.Msg.COLOUR_SATURATION_LABEL = 'Saturation';
Blockly.Msg.COLOUR_BRIGHTNESS_LABEL = 'Brightness';

// Variables
// @todo Remove these once fully managed by Scratch VM / Scratch GUI
Blockly.Msg.CHANGE_VALUE_TITLE = 'Change value:';
Blockly.Msg.RENAME_VARIABLE = 'Rename variable';
Blockly.Msg.RENAME_VARIABLE_TITLE = 'Rename all "%1" variables to:';
Blockly.Msg.RENAME_VARIABLE_MODAL_TITLE = 'Rename Variable';
Blockly.Msg.NEW_VARIABLE = 'Make a Variable';
Blockly.Msg.NEW_VARIABLE_TITLE = 'New variable name:';
Blockly.Msg.VARIABLE_MODAL_TITLE = 'New Variable';
Blockly.Msg.VARIABLE_ALREADY_EXISTS = 'A variable named "%1" already exists.';
Blockly.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE = 'A variable named "%1" already exists for another variable of type "%2".';
Blockly.Msg.DELETE_VARIABLE_CONFIRMATION = 'Delete %1 uses of the "%2" variable?';
Blockly.Msg.CANNOT_DELETE_VARIABLE_PROCEDURE = 'Can\'t delete the variable "%1" because it\'s part of the definition of the function "%2"';
Blockly.Msg.DELETE_VARIABLE = 'Delete the "%1" variable';

// Custom Procedures (Functions)
// @todo Remove these once fully managed by Scratch VM / Scratch GUI
Blockly.Msg.NEW_PROCEDURE = 'Make a Function';
Blockly.Msg.PROCEDURE_ALREADY_EXISTS = 'A function named "%1" already exists.';
Blockly.Msg.PROCEDURE_DEFAULT_NAME = 'function name';
Blockly.Msg.PROCEDURE_USED = 'To delete a function definition, first remove all uses of the function';

// Lists
// @todo Remove these once fully managed by Scratch VM / Scratch GUI
Blockly.Msg.NEW_LIST = 'Make a List';
Blockly.Msg.NEW_LIST_TITLE = 'New list name:';
Blockly.Msg.LIST_MODAL_TITLE = 'New List';
Blockly.Msg.LIST_ALREADY_EXISTS = 'A list named "%1" already exists.';
Blockly.Msg.RENAME_LIST_TITLE = 'Rename all "%1" lists to:';
Blockly.Msg.RENAME_LIST_MODAL_TITLE = 'Rename List';
Blockly.Msg.DEFAULT_LIST_ITEM = 'thing';
Blockly.Msg.DELETE_LIST = 'Delete the "%1" list';
Blockly.Msg.RENAME_LIST = 'Rename list';

// Broadcast Messages
// @todo Remove these once fully managed by Scratch VM / Scratch GUI
Blockly.Msg.NEW_BROADCAST_MESSAGE = 'New message';
Blockly.Msg.NEW_BROADCAST_MESSAGE_TITLE = 'New message name:';
Blockly.Msg.BROADCAST_MODAL_TITLE = 'New Message';
Blockly.Msg.DEFAULT_BROADCAST_MESSAGE_NAME = 'message1';

// Shortcuts & Keyboard navigation
Blockly.Msg.DIALOG_OK = 'OK';
Blockly.Msg.DIALOG_CANCEL = 'Cancel';
Blockly.Msg.SHORTCUTS_ESCAPE = 'Exit';
Blockly.Msg.SHORTCUTS_DELETE = 'Delete';
Blockly.Msg.SHORTCUTS_START_MOVE = 'Start move';
Blockly.Msg.SHORTCUTS_START_MOVE_STACK = 'Start move stack';
Blockly.Msg.SHORTCUTS_MOVE_LEFT = 'Move left';
Blockly.Msg.SHORTCUTS_MOVE_RIGHT = 'Move right';
Blockly.Msg.SHORTCUTS_MOVE_UP = 'Move up';
Blockly.Msg.SHORTCUTS_MOVE_DOWN = 'Move down';
Blockly.Msg.SHORTCUTS_FINISH_MOVE = 'Finish move';
Blockly.Msg.SHORTCUTS_ABORT_MOVE = 'Abort move';
Blockly.Msg.SHORTCUTS_SHOW_CONTEXT_MENU = 'Show menu';
Blockly.Msg.SHORTCUTS_FOCUS_WORKSPACE = 'Focus workspace';
Blockly.Msg.SHORTCUTS_FOCUS_TOOLBOX = 'Focus toolbox';
Blockly.Msg.SHORTCUTS_INFORMATION = 'Announce information';
Blockly.Msg.SHORTCUTS_EXTENDED_INFORMATION = 'Announce detailed information';
Blockly.Msg.SHORTCUTS_DISCONNECT = 'Disconnect block';
Blockly.Msg.SHORTCUTS_NEXT_STACK = 'Next stack';
Blockly.Msg.SHORTCUTS_PREVIOUS_STACK = 'Previous stack';
Blockly.Msg.SHORTCUTS_NEXT_HEADING = 'Next heading';
Blockly.Msg.SHORTCUTS_PREVIOUS_HEADING = 'Previous heading';
Blockly.Msg.SHORTCUTS_PERFORM_ACTION = 'Edit or confirm';
Blockly.Msg.SHORTCUTS_DUPLICATE = 'Duplicate';
Blockly.Msg.SHORTCUTS_CLEANUP = 'Clean up workspace';
Blockly.Msg.SHORTCUTS_SHOW_TOOLTIP = 'Show tooltip';
Blockly.Msg.SHORTCUTS_TOGGLE_SCREENREADER_MODE = 'Toggle screenreader mode';
Blockly.Msg.SHORTCUTS_JUMP_BLOCK_START = 'Jump to block start';
Blockly.Msg.SHORTCUTS_JUMP_BLOCK_END = 'Jump to block end';
Blockly.Msg.SHORTCUTS_JUMP_TOP_STACK = 'Jump to top of stack';
Blockly.Msg.SHORTCUTS_JUMP_BOTTOM_STACK = 'Jump to bottom of stack';
Blockly.Msg.SHORTCUTS_JUMP_FIRST_BLOCK = 'Jump to first block';
Blockly.Msg.SHORTCUTS_JUMP_LAST_BLOCK = 'Jump to last block';
Blockly.Msg.KEYBOARD_NAV_UNCONSTRAINED_MOVE_HINT = 'Hold %1 and use arrow keys to move freely, then %2 to accept the position.';
Blockly.Msg.CONTROL_KEY = 'Control';
Blockly.Msg.COMMAND_KEY = 'Command';
Blockly.Msg.OPTION_KEY = 'Option';
Blockly.Msg.ALT_KEY = 'Alt';
Blockly.Msg.ENTER_KEY = 'Enter';
Blockly.Msg.BACKSPACE_KEY = 'Backspace';
Blockly.Msg.DELETE_KEY = 'Delete';
Blockly.Msg.ESCAPE = 'Escape';
Blockly.Msg.TAB_KEY = 'Tab';
Blockly.Msg.SHIFT_KEY = 'Shift';
Blockly.Msg.CAPS_LOCK_KEY = 'Caps Lock';
Blockly.Msg.SPACE_KEY = 'Space';
Blockly.Msg.PAGE_UP_KEY = 'Page Up';
Blockly.Msg.PAGE_DOWN_KEY = 'Page Down';
Blockly.Msg.END_KEY = 'End';
Blockly.Msg.HOME_KEY = 'Home';
Blockly.Msg.INSERT_KEY = 'Insert';
Blockly.Msg.PAUSE_KEY = 'Pause';
Blockly.Msg.CONTEXT_MENU_KEY = '≣ Menu';
Blockly.Msg.CUT_SHORTCUT = 'Cut';
Blockly.Msg.COPY_SHORTCUT = 'Copy';
Blockly.Msg.PASTE_SHORTCUT = 'Paste';
Blockly.Msg.HELP_PROMPT = 'Press %1 for help on keyboard controls.';
Blockly.Msg.KEYBOARD_NAV_CONSTRAINED_MOVE_HINT = 'Use the arrow keys to move, then %1 to accept the position.';
Blockly.Msg.WORKSPACE_LABEL_PLAIN = 'Blocks workspace.';
Blockly.Msg.WORKSPACE_ROLEDESCRIPTION = 'workspace';
Blockly.Msg.WORKSPACE_LABEL_1_STACK = '1 stack of blocks';
Blockly.Msg.WORKSPACE_LABEL_MANY_STACKS = '%1 stacks of blocks';
Blockly.Msg.WORKSPACE_LABEL_MUTATOR_WORKSPACE = 'Block editor workspace';
Blockly.Msg.WORKSPACE_LABEL_FLYOUT_WORKSPACE = '%1 blocks';
Blockly.Msg.KEYBOARD_NAV_BLOCK_NAVIGATION_HINT = 'Use %1 to navigate inside of blocks.';
Blockly.Msg.KEYBOARD_NAV_WORKSPACE_NAVIGATION_HINT = 'Use the arrow keys to navigate.';
Blockly.Msg.KEYBOARD_NAV_FLYOUT_LABEL_HINT = 'Use the arrow keys to navigate to a block, or press %1 to go to the next heading.';
Blockly.Msg.BLOCK_LABEL_BEGIN_STACK = 'Begin stack';
Blockly.Msg.BLOCK_LABEL_BEGIN_PREFIX = 'Begin %1';
Blockly.Msg.BLOCK_LABEL_TOOLBOX_CATEGORY = '%1 category';
Blockly.Msg.BLOCK_LABEL_DISABLED = 'disabled';
Blockly.Msg.BLOCK_LABEL_COLLAPSED = 'collapsed';
Blockly.Msg.BLOCK_LABEL_REPLACEABLE = 'replaceable';
Blockly.Msg.BLOCK_LABEL_HAS_INPUT = 'has input';
Blockly.Msg.BLOCK_LABEL_HAS_INPUTS = 'has inputs';
Blockly.Msg.BLOCK_LABEL_HAS_BRANCHES = 'has %1 branches';
Blockly.Msg.BLOCK_LABEL_STATEMENT = 'statement';
Blockly.Msg.BLOCK_LABEL_CONTAINER = 'container';
Blockly.Msg.BLOCK_LABEL_VALUE = 'value';
Blockly.Msg.BLOCK_LABEL_STACK_BLOCKS = '%1 stack blocks';
Blockly.Msg.INPUT_LABEL_INDEX = 'input %1';
Blockly.Msg.INPUT_LABEL_VALUE = 'value position';
Blockly.Msg.INPUT_LABEL_STATEMENT = 'statement position';
Blockly.Msg.INPUT_LABEL_END_STATEMENT = 'End %1';
Blockly.Msg.INPUT_LABEL_EMPTY = 'Empty';
Blockly.Msg.ANNOUNCE_MOVE_WORKSPACE = 'Moving %1 on workspace.';
Blockly.Msg.ANNOUNCE_MOVE_BEFORE = 'Moving %1 before %2.';
Blockly.Msg.ANNOUNCE_MOVE_AFTER = 'Moving %1 after %2.';
Blockly.Msg.ANNOUNCE_MOVE_INSIDE = 'Moving %1 inside %2.';
Blockly.Msg.ANNOUNCE_MOVE_AROUND = 'Moving %1 around %2.';
Blockly.Msg.ANNOUNCE_MOVE_TO = 'Moving %1 to %2.';
Blockly.Msg.ANNOUNCE_MOVE_OF = '%1 of %2';
Blockly.Msg.ANNOUNCE_MOVE_CANCELED = 'Canceled movement.';
Blockly.Msg.FIELD_LABEL_EMPTY = 'empty';
Blockly.Msg.ARIA_TYPE_FIELD_INPUT = 'input';
Blockly.Msg.ARIA_TYPE_FIELD_TEXT_INPUT = 'text';
Blockly.Msg.ARIA_TYPE_FIELD_NUMBER = 'number';
Blockly.Msg.ARIA_TYPE_FIELD_DROPDOWN = 'dropdown';
Blockly.Msg.ARIA_TYPE_FIELD_IMAGE = 'image';
Blockly.Msg.ARIA_TYPE_FIELD_CHECKBOX = 'checkbox';
Blockly.Msg.FIELD_LABEL_EDIT_PREFIX = 'Edit %1';
Blockly.Msg.OPEN_TRASH = 'Open trash';
Blockly.Msg.ZOOM_IN = 'Zoom in';
Blockly.Msg.ZOOM_OUT = 'Zoom out';
Blockly.Msg.RESET_ZOOM = 'Reset zoom';
Blockly.Msg.FIELD_LABEL_OPTION_INDEX = 'Option %1';
Blockly.Msg.FIELD_LABEL_CHECKBOX_CHECKED = 'Checked';
Blockly.Msg.FIELD_LABEL_CHECKBOX_UNCHECKED = 'Not checked';
Blockly.Msg.FIELD_LABEL_VARIABLE = 'Variable "%1"';
Blockly.Msg.ARIA_LABEL_BUTTON = 'button';
Blockly.Msg.ARIA_LABEL_HEADING = 'heading';
Blockly.Msg.BUBBLE_LABEL_DEFAULT = 'Bubble';
Blockly.Msg.BUBBLE_LABEL_COMMENT = 'Comment: %1';
Blockly.Msg.BUBBLE_LABEL_WARNING = 'Warning: %1';
Blockly.Msg.ICON_LABEL_DEFAULT = 'Icon';
Blockly.Msg.ICON_LABEL_COMMENT_CLOSED = 'Open Comment';
Blockly.Msg.ICON_LABEL_COMMENT_OPEN = 'Close Comment';
Blockly.Msg.ICON_LABEL_MUTATOR_CLOSED = 'Edit this block';
Blockly.Msg.ICON_LABEL_MUTATOR_OPEN = 'Close block editor';
Blockly.Msg.ICON_LABEL_WARNING_CLOSED = 'Open Warning';
Blockly.Msg.ICON_LABEL_WARNING_OPEN = 'Close Warning';
Blockly.Msg.ARIA_LABEL_COMMENT = 'Comment';
Blockly.Msg.ARIA_LABEL_COMMENT_COLLAPSE = 'Collapse Comment';
Blockly.Msg.ARIA_LABEL_COMMENT_EXPAND = 'Expand Comment';
Blockly.Msg.SCREENREADER_MODE_ENABLED = 'Screenreader mode is on, press %1 to turn it off';
Blockly.Msg.SCREENREADER_MODE_DISABLED = 'Screenreader mode is off, press %1 to turn it on';
Blockly.Msg.CURRENT_BLOCK_ANNOUNCEMENT = 'Current block: %1';
Blockly.Msg.PARENT_BLOCKS_ANNOUNCEMENT = 'Parent blocks: %1';
Blockly.Msg.NO_PARENT_ANNOUNCEMENT = 'Current block has no parent';
Blockly.Msg.SCREENREADER_HINT = 'Use the arrow keys to navigate. Press %1 to toggle screenreader accessibility mode.';
Blockly.Msg.ARIA_LABEL_TRASH_EMPTY = 'Trash, currently empty';

for (const lang in locale) locale[lang] = Object.assign({}, Blockly.Msg, locale[lang]);
export default locale;
